import { render, staticRenderFns } from "./CourseReserveButton.vue?vue&type=template&id=4654e381&scoped=true&"
import script from "./CourseReserveButton.vue?vue&type=script&lang=ts&"
export * from "./CourseReserveButton.vue?vue&type=script&lang=ts&"
import style0 from "./CourseReserveButton.vue?vue&type=style&index=0&id=4654e381&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654e381",
  null
  
)

export default component.exports